export const formInputKeys = {
  all: () => ['formImput'],
  publicIcons: () => [formInputKeys.all(), 'publicIcons'],
};
